(function () {
  /* Script is included once per pmg section — only run the first copy */
  if (window.__pmgGalleryInit) return;
  window.__pmgGalleryInit = true;

  /* ---------- Fullscreen lightbox ---------- */
  var lightboxEl = null;

  function largestSrc(img) {
    var srcset = img.getAttribute('srcset');
    if (srcset) {
      var best = null;
      srcset.split(',').forEach(function (entry) {
        var parts = entry.trim().split(/\s+/);
        var url = parts[0];
        var w = parseInt((parts[1] || '').replace('w', ''), 10) || 0;
        if (!best || w > best.w) best = { url: url, w: w };
      });
      if (best) return best.url;
    }
    return img.currentSrc || img.src;
  }

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'pmg-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image gallery');
    el.innerHTML =
      '<div class="pmg-lightbox__backdrop" data-pmg-lb-close></div>' +
      '<div class="pmg-lightbox__toolbar">' +
      '<button type="button" class="pmg-lightbox__tool" data-pmg-lb-zoom-out aria-label="Zoom out">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="M8 11h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="pmg-lightbox__tool" data-pmg-lb-zoom-in aria-label="Zoom in">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="M8 11h6M11 8v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M16.5 16.5L21 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="pmg-lightbox__tool" data-pmg-lb-close aria-label="Close">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="pmg-lightbox__counter" data-pmg-lb-counter></div>' +
      '<div class="pmg-lightbox__viewport" data-pmg-lb-viewport>' +
      '<div class="pmg-lightbox__track" data-pmg-lb-track></div>' +
      '</div>' +
      '<button type="button" class="pmg-lightbox__arrow pmg-lightbox__arrow--prev" data-pmg-lb-prev aria-label="Previous image">' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="pmg-lightbox__arrow pmg-lightbox__arrow--next" data-pmg-lb-next aria-label="Next image">' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    document.body.appendChild(el);
    return el;
  }

  function openLightbox(items, startIndex) {
    if (!items.length) return;
    if (!lightboxEl) lightboxEl = buildLightbox();

    var el = lightboxEl;
    var track = el.querySelector('[data-pmg-lb-track]');
    var viewport = el.querySelector('[data-pmg-lb-viewport]');
    var counter = el.querySelector('[data-pmg-lb-counter]');
    var prevBtn = el.querySelector('[data-pmg-lb-prev]');
    var nextBtn = el.querySelector('[data-pmg-lb-next]');
    var zoomInBtn = el.querySelector('[data-pmg-lb-zoom-in]');
    var zoomOutBtn = el.querySelector('[data-pmg-lb-zoom-out]');
    var index = startIndex;
    var total = items.length;

    /* Zoom state (applies to the current image only) */
    var ZOOM_MIN = 1;
    var ZOOM_MAX = 4;
    var ZOOM_STEP = 1.5;
    var zoom = 1;
    var panX = 0;
    var panY = 0;

    track.innerHTML = '';
    items.forEach(function (item) {
      var slide = document.createElement('div');
      slide.className = 'pmg-lightbox__slide';
      var img = document.createElement('img');
      img.className = 'pmg-lightbox__img';
      img.alt = item.alt;
      img.setAttribute('data-src', item.src);
      slide.appendChild(img);
      track.appendChild(slide);
    });
    var slideImgs = track.querySelectorAll('.pmg-lightbox__img');

    function loadAround(i) {
      for (var k = Math.max(0, i - 1); k <= Math.min(total - 1, i + 1); k++) {
        var img = slideImgs[k];
        if (img && !img.src) img.src = img.getAttribute('data-src');
      }
    }

    function currentImg() {
      return slideImgs[index];
    }

    function clampPan() {
      /* Keep the zoomed image from being dragged fully out of view */
      var maxX = ((zoom - 1) * viewport.clientWidth) / 2;
      var maxY = ((zoom - 1) * viewport.clientHeight) / 2;
      panX = Math.max(-maxX, Math.min(maxX, panX));
      panY = Math.max(-maxY, Math.min(maxY, panY));
    }

    function applyZoom(animate) {
      var img = currentImg();
      if (!img) return;
      clampPan();
      img.style.transition = animate === false ? 'none' : '';
      img.style.transform = zoom > 1
        ? 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoom + ')'
        : '';
      el.classList.toggle('is-zoomed', zoom > 1);
      zoomInBtn.disabled = zoom >= ZOOM_MAX;
      zoomOutBtn.disabled = zoom <= ZOOM_MIN;
    }

    function setZoom(z) {
      zoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, z));
      if (zoom === 1) {
        panX = 0;
        panY = 0;
      }
      applyZoom();
    }

    function resetZoom() {
      var img = currentImg();
      zoom = 1;
      panX = 0;
      panY = 0;
      if (img) {
        img.style.transition = 'none';
        img.style.transform = '';
      }
      el.classList.remove('is-zoomed');
      zoomInBtn.disabled = false;
      zoomOutBtn.disabled = true;
    }

    function apply(animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      counter.textContent = (index + 1) + ' / ' + total;
      prevBtn.style.display = total > 1 ? '' : 'none';
      nextBtn.style.display = total > 1 ? '' : 'none';
      counter.style.display = total > 1 ? '' : 'none';
      loadAround(index);
    }

    function goTo(i, animate) {
      resetZoom();
      index = ((i % total) + total) % total;
      apply(animate);
    }

    function close() {
      resetZoom();
      el.classList.remove('is-open');
      document.body.classList.remove('pmg-lightbox-open');
      document.removeEventListener('keydown', onKey);
      prevBtn.removeEventListener('click', onPrev);
      nextBtn.removeEventListener('click', onNext);
      zoomInBtn.removeEventListener('click', onZoomIn);
      zoomOutBtn.removeEventListener('click', onZoomOut);
      el.querySelectorAll('[data-pmg-lb-close]').forEach(function (btn) {
        btn.removeEventListener('click', close);
      });
      viewport.removeEventListener('pointerdown', onDown);
      viewport.removeEventListener('pointermove', onMove);
      viewport.removeEventListener('pointerup', onUp);
      viewport.removeEventListener('pointercancel', onUp);
      viewport.removeEventListener('click', onViewportClick);
      viewport.removeEventListener('dblclick', onDblClick);
      pointers = {};
    }

    function onPrev() { goTo(index - 1); }
    function onNext() { goTo(index + 1); }
    function onZoomIn() { setZoom(zoom * ZOOM_STEP); }
    function onZoomOut() { setZoom(zoom / ZOOM_STEP); }

    function onDblClick(e) {
      if (zoom > 1) setZoom(1);
      else setZoom(2);
      e.preventDefault();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') onPrev();
      else if (e.key === 'ArrowRight') onNext();
      else if (e.key === '+' || e.key === '=') onZoomIn();
      else if (e.key === '-') onZoomOut();
    }

    /* Pointer handling (touch + mouse):
       - 1 finger, not zoomed  -> swipe between images
       - 1 finger, zoomed      -> pan the image
       - 2 fingers             -> pinch to zoom */
    var pointers = {};
    var dragStartX = 0;
    var dragStartY = 0;
    var dragDelta = 0;
    var dragging = false;
    var panning = false;
    var panStartX = 0;
    var panStartY = 0;
    var pinching = false;
    var pinchStartDist = 1;
    var pinchStartZoom = 1;
    var pinchStartPanX = 0;
    var pinchStartPanY = 0;
    var pinchCenterX = 0;
    var pinchCenterY = 0;

    function pointerList() {
      return Object.keys(pointers).map(function (id) { return pointers[id]; });
    }

    function pointerDist(a, b) {
      var dx = a.x - b.x;
      var dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function startPinch() {
      var pts = pointerList();
      dragging = false;
      panning = false;
      pinching = true;
      track.style.transition = '';
      pinchStartDist = pointerDist(pts[0], pts[1]) || 1;
      pinchStartZoom = zoom;
      pinchStartPanX = panX;
      pinchStartPanY = panY;
      var rect = viewport.getBoundingClientRect();
      var midX = (pts[0].x + pts[1].x) / 2;
      var midY = (pts[0].y + pts[1].y) / 2;
      pinchCenterX = midX - (rect.left + rect.width / 2);
      pinchCenterY = midY - (rect.top + rect.height / 2);
    }

    function onDown(e) {
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      viewport.setPointerCapture && viewport.setPointerCapture(e.pointerId);
      var count = pointerList().length;
      if (count === 2) {
        startPinch();
        return;
      }
      if (count > 2) return;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragDelta = 0;
      if (zoom > 1) {
        panning = true;
        panStartX = panX;
        panStartY = panY;
      } else if (total > 1) {
        dragging = true;
        track.style.transition = 'none';
      }
    }

    function onMove(e) {
      if (!pointers[e.pointerId]) return;
      pointers[e.pointerId].x = e.clientX;
      pointers[e.pointerId].y = e.clientY;

      if (pinching) {
        var pts = pointerList();
        if (pts.length < 2) return;
        var ratio = pointerDist(pts[0], pts[1]) / pinchStartDist;
        var newZoom = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, pinchStartZoom * ratio));
        var scaleDelta = newZoom / pinchStartZoom;
        panX = pinchStartPanX - pinchCenterX * (scaleDelta - 1);
        panY = pinchStartPanY - pinchCenterY * (scaleDelta - 1);
        zoom = newZoom;
        applyZoom(false);
        return;
      }

      if (panning) {
        dragDelta = e.clientX - dragStartX;
        panX = panStartX + (e.clientX - dragStartX);
        panY = panStartY + (e.clientY - dragStartY);
        applyZoom(false);
        return;
      }

      if (!dragging) return;
      dragDelta = e.clientX - dragStartX;
      var pct = (dragDelta / viewport.clientWidth) * 100;
      track.style.transform = 'translateX(calc(-' + index * 100 + '% + ' + pct + '%))';
    }

    function onUp(e) {
      delete pointers[e.pointerId];
      var count = pointerList().length;

      if (pinching) {
        if (count < 2) {
          pinching = false;
          if (zoom <= ZOOM_MIN + 0.01) {
            setZoom(1);
          } else {
            applyZoom();
          }
          if (count === 1 && zoom > 1) {
            var rem = pointerList()[0];
            dragStartX = rem.x;
            dragStartY = rem.y;
            dragDelta = 0;
            panning = true;
            panStartX = panX;
            panStartY = panY;
          }
        }
        return;
      }

      if (panning) {
        if (count === 0) panning = false;
        return;
      }

      if (!dragging) return;
      if (count > 0) return;
      dragging = false;
      track.style.transition = '';
      var threshold = Math.min(80, viewport.clientWidth * 0.15);
      if (dragDelta > threshold) goTo(index - 1);
      else if (dragDelta < -threshold) goTo(index + 1);
      else apply();
    }

    function onViewportClick(e) {
      /* Close when tapping the empty area around the image (not after a swipe/pan) */
      if (Math.abs(dragDelta) > 10) return;
      if (zoom > 1) return;
      if (e.target === viewport || e.target.classList.contains('pmg-lightbox__slide')) close();
    }

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);
    zoomInBtn.addEventListener('click', onZoomIn);
    zoomOutBtn.addEventListener('click', onZoomOut);
    el.querySelectorAll('[data-pmg-lb-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', onKey);
    viewport.addEventListener('pointerdown', onDown);
    viewport.addEventListener('pointermove', onMove);
    viewport.addEventListener('pointerup', onUp);
    viewport.addEventListener('pointercancel', onUp);
    viewport.addEventListener('click', onViewportClick);
    viewport.addEventListener('dblclick', onDblClick);

    document.body.classList.add('pmg-lightbox-open');
    el.classList.add('is-open');
    pointers = {};
    resetZoom();
    goTo(startIndex, false);
  }

  function initLightboxTriggers(root) {
    var imgs = root.querySelectorAll('.pmg__img');
    if (!imgs.length) return;
    var items = Array.prototype.map.call(imgs, function (img) {
      return { src: largestSrc(img), alt: img.alt || '' };
    });
    Array.prototype.forEach.call(imgs, function (img, i) {
      img.classList.add('pmg__img--zoomable');
      img.addEventListener('click', function () {
        openLightbox(items, i);
      });
    });
  }

  function initPmg(root) {
    if (root.dataset.pmgInitialized) return;
    root.dataset.pmgInitialized = 'true';
    initLightboxTriggers(root);
    var viewport = root.querySelector('.pmg__viewport');
    var track = root.querySelector('.pmg__track');
    var prevBtn = root.querySelector('[data-pmg-prev]');
    var nextBtn = root.querySelector('[data-pmg-next]');
    var dotsHost = root.querySelector('[data-pmg-dots]');
    var pillsWrap = root.querySelector('[data-pmg-pills]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('.pmg__slide');
    var total = slides.length;
    if (total === 0) return;

    var index = 0;
    var dots = [];

    function renderDots() {
      if (!dotsHost || total <= 1) return;
      dotsHost.innerHTML = '';
      dots = [];
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pmg__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + total);
        b.addEventListener('click', function (pos) {
          return function () {
            goTo(pos);
          };
        }(i));
        dotsHost.appendChild(b);
        dots.push(b);
      }
    }

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function updatePills() {
      if (!pillsWrap) return;
      var pillBtns = pillsWrap.querySelectorAll('[data-pmg-pill]');
      pillBtns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
    }

    function apply() {
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      updateDots();
      updatePills();
      if (prevBtn) {
        prevBtn.disabled = total <= 1;
        prevBtn.setAttribute('aria-disabled', total <= 1 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.disabled = total <= 1;
        nextBtn.setAttribute('aria-disabled', total <= 1 ? 'true' : 'false');
      }
    }

    function goTo(i) {
      index = ((i % total) + total) % total;
      apply();
    }

    function prev() {
      goTo(index - 1);
    }

    function next() {
      goTo(index + 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    if (pillsWrap) {
      pillsWrap.querySelectorAll('[data-pmg-pill]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var raw = btn.getAttribute('data-pmg-pill');
          var pillIdx = parseInt(raw, 10);
          if (isNaN(pillIdx)) return;
          goTo(pillIdx);
        });
      });
    }

    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        prev();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        next();
        e.preventDefault();
      }
    });

    renderDots();
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-pmg-root]').forEach(initPmg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
